module.exports = __webpack_public_path__ + "static/media/bg.ff2ced97.webp";